// Dark is the product default (the design board is dark); light is an opt-in preference.
export type ThemePref = 'dark' | 'light';
const KEY = 'ayx-theme';

export function getTheme(): ThemePref {
  try { return localStorage.getItem(KEY) === 'light' ? 'light' : 'dark'; } catch { return 'dark'; }
}

export function applyTheme(pref: ThemePref) {
  document.documentElement.setAttribute('data-theme', pref);
  try { localStorage.setItem(KEY, pref); } catch { /* storage unavailable */ }
  window.dispatchEvent(new CustomEvent('ayx:theme', { detail: pref }));
}
